import { render, staticRenderFns } from "./apvsbrasil.vue?vue&type=template&id=1bd35ac6&scoped=true"
import script from "./apvsbrasil.vue?vue&type=script&lang=js"
export * from "./apvsbrasil.vue?vue&type=script&lang=js"
import style0 from "./apvsbrasil.vue?vue&type=style&index=0&id=1bd35ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd35ac6",
  null
  
)

export default component.exports